module.exports = __webpack_public_path__ + "img/withdraw.1fba5d8c.svg";